import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { CustomerGuide } from '../../../class/customer-guide';

@Component({
  selector: 'app-customer-guide',
  templateUrl: './customer-guide.component.html',
  styleUrls: ['./customer-guide.component.scss']
})
export class CustomerGuideComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoCustomerGuide: CustomerGuide;
    public customerGuide: CustomerGuide;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public customerGuideService: CustomerGuideService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelCustomerGuide () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/customer-guides/customer-guide/customer-guide.component.ts